// Dev-only Telegram initData mock generator.
// SECURITY: Never enable in production. Used purely for local development when Telegram Mini App environment is unavailable.
// It creates a plausible initData string that matches the structure returned by Telegram WebApp, adding a marker `mock=1`.

interface MockOptions {
  userId?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  isPremium?: boolean;
  languageCode?: string;
}

export const isTelegramMockEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  const flagParam = params.get("tg_mock");
  const envFlag = (
    import.meta as unknown as {
      env?: Record<string, string | boolean | undefined>;
    }
  ).env?.VITE_TELEGRAM_MOCK;
  const dev = !!import.meta.env.DEV;
  const enabled = flagParam === "1" || (dev && envFlag === "1");
  if (dev) {
    // Only log in dev to avoid noise in production console if someone deploys with ?tg_mock
    console.log("[MockMode] computed", {
      queryFlag: flagParam === "1",
      envFlag: envFlag === "1",
      dev,
      enabled,
    });
  }
  return enabled;
};

export interface MockUserPayload {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
}

export function buildMockInitData(options: MockOptions = {}): {
  initData: string;
  user: MockUserPayload;
} {
  const nowSec = Math.floor(Date.now() / 1000);
  const user = {
    id: options.userId ?? 999999999,
    first_name: options.firstName ?? "Dev",
    last_name: options.lastName ?? "User",
    username: options.username ?? "dev_user",
    language_code: options.languageCode ?? "en",
    is_premium: options.isPremium ?? false,
  };
  // Fake start_param & query_id for completeness
  const params = new URLSearchParams();
  params.set("user", JSON.stringify(user));
  params.set("auth_date", String(nowSec));
  params.set("start_param", "ref_DEV123");
  params.set("query_id", "AAAAAAAAAAAAAAAA");
  params.set("mock", "1");
  // Provide a 64-length hex so basic length/format checks pass if any (server bypass will still be required)
  params.set(
    "hash",
    "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
  );
  return { initData: params.toString(), user };
}
